export default [{
    path: '/mine/settingMail',
    name: 'settingMail',
    meta: {
      index: 14
    },
    component: () => import('@/views/mine/settingMail.vue')
  }]
  